import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { clearFilters, clearSelections } from '@emi/shared/state/filters';
import * as Constants from '@emi/shared/constants';
import { SaveAndExtractComponent } from '@emi/shared/feature/save-and-extract';
import { GenericModalComponent } from 'libs/shared/ui/src/lib/generic-modal/generic-modal.component';

@Injectable()
export class SaveAndExtractCanDeactivateGuard implements CanDeactivate<SaveAndExtractComponent> {
    constructor(private dialog: MatDialog) {}
    async canDeactivate(
        component: SaveAndExtractComponent,
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): Promise<boolean> {
        const showLeaveModal = JSON.parse(localStorage.getItem(component.modalType) ?? 'true');
        if (
            showLeaveModal &&
            nextState.url !== `/${Constants.Routes.CONFIGURE_DATA_ROUTE}` &&
            nextState.url !== `/${Constants.Routes.SUCCESS_ROUTE}` &&
            nextState.url !== `/${Constants.Routes.SYSTEM_ERROR}` &&
            nextState.url !== `/${Constants.Routes.SKU_SEARCH_CONFIGURE_DATA_ROUTE}` &&
            nextState.url !== `/${Constants.Routes.SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE}`&&
            nextState.url !== `/${Constants.Routes.SAVE_AND_EXTRACT_ROUTE}`
        ) {
            const dialogRef = this.dialog.open(GenericModalComponent, {
                width: '340px',
                data: {
                    buttons: {
                        primary: 'Proceed',
                        secondary: 'Cancel',
                    },
                    content: 'Leaving will clear all your current selections, are you sure you want to leave?',
                    iconClass: 'fa-solid fa-triangle-exclamation',
                    title: 'Discard Current Selections',
                    type: component.modalType,
                    showUnderstoodCheckbox: true,
                },
            });

            return await dialogRef
                .afterClosed()
                .toPromise()
                .then((result) => {
                    if (result) {
                        component.store.dispatch(clearFilters());
                        component.store.dispatch(clearSelections());
                        return true;
                    }
                    return false;
                });
        }
        if (
            [
                `/${Constants.Routes.SAVE_AND_EXTRACT_ROUTE}`,
                `/${Constants.Routes.SKU_SEARCH_SAVE_AND_EXTRACT_ROUTE}`,
                `/${Constants.Routes.SUCCESS_ROUTE}`,
                `/${Constants.Routes.CONFIGURE_DATA_ROUTE}`,
                `/${Constants.Routes.SKU_SEARCH_CONFIGURE_DATA_ROUTE}`
            ].includes(nextState.url)
        ) {
            return true;
        }

        component.store.dispatch(clearFilters());
        component.store.dispatch(clearSelections());
        return true;
    }
}
